import React, { useState } from 'react';
import clsx from 'clsx';
import {
    Button,
    Popover,
    Radio,
    Checkbox,
    Icons
} from 'components';
import './style.scss';
import { IBaseMapConf } from 'types';
import { BaseLayersListUL } from './layers-list';

export interface IBaseMapSwitcher {
    className?: string;
    layersList: IBaseMapConf[];
    lng: string,
    currentBaseMapId: number,
    cadastreIsVisible: boolean
    showCadastreLayer: (boolean) => void
    switchBaseMap: (number) => void
}

export const BaseMapSwitcher: React.FC<IBaseMapSwitcher> = (props): JSX.Element => {
    const [ referenceElement, setReferenceElement ] = useState(null);
    const [ showPopover, setShowPopover ] = useState(false);

    return (
        <React.Fragment>
            <Button
                ref={setReferenceElement}
                onClick={() => setShowPopover(true)}
                onMouseEnter={() => setShowPopover(true)}
                onMouseLeave={() => setShowPopover(false)}
                icon={<Icons.IconLayers />}
                variant='black'
            />
            <Popover
                hideTimeout={300}
                showTimeout={300}
                targetElement={referenceElement}
                offset={[ 0, 4 ]}
                placement="left-start"
                open={showPopover}
            >
                <BaseLayersListUL {...props} />
            </Popover>
        </React.Fragment>
    );
};
